import achiveSoundFile from "../assets/sound/achive.mp4";
import { playAppSound } from "./playAppSound";

export const playAchiveSound = () => {
  playAppSound(achiveSoundFile).catch((err) =>
    console.error("Audio play error (action):", err),
  );
};
